/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * filterregel-acties.component.ts
 * Gegenereerd met Junie (AI), 07-10-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Compacte knoppenbalk voor bewerkingsacties bij een filterregel.
 */

import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

/**
 * Compacte knoppenbalk naast een regel-editor.
 * Bevat acties om de regel uit de huidige groep te verplaatsen, de regel in een EN/OF-groep te wikkelen
 * en de regel te verwijderen.
 */
@Component({
  standalone: true,
  selector: 'filterregel-acties',
  imports: [CommonModule],
  templateUrl: './filterregel-acties.component.html',
  styleUrls: ['./filterregel-acties.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterregelActiesComponent {
  // Inputs (properties)
  /** De id van de clausule (regel) waarop de acties worden uitgevoerd. */
  @Input({required: true}) clausuleId!: string;
  /** True wanneer de regel direct onder de root-groep valt. */
  @Input() isInRootGroep: boolean = false;

  // Outputs
  /** Verzoekt om de regel één niveau omhoog te verplaatsen (uit de huidige groep). */
  @Output() uitDezeGroep = new EventEmitter<string>();
  /** Verzoekt om de regel in een EN-groep te wikkelen. */
  @Output() wikkelInEn = new EventEmitter<string>();
  /** Verzoekt om de regel in een OF-groep te wikkelen. */
  @Output() wikkelInOf = new EventEmitter<string>();
  /** Verzoekt om de regel te verwijderen. */
  @Output() verwijder = new EventEmitter<string>();

  // Public methods
  /**
   * Emit verplaats-event wanneer de regel niet in de rootgroep zit.
   */
  public klikUitDezeGroep(): void {
    if (!this.isInRootGroep) {
      this.uitDezeGroep.emit(this.clausuleId);
    }
  }

  /**
   * Emit evenement om de regel in een EN-groep te wikkelen.
   */
  public klikWikkelEn(): void {
    this.wikkelInEn.emit(this.clausuleId);
  }

  /**
   * Emit evenement om de regel in een OF-groep te wikkelen.
   */
  public klikWikkelOf(): void {
    this.wikkelInOf.emit(this.clausuleId);
  }

  /**
   * Emit een verwijderverzoek voor deze clausule-id.
   */
  public klikVerwijder(): void {
    this.verwijder.emit(this.clausuleId);
  }
}
